(function() {
    "use strict";

    const popularPlantsBtn = document.querySelector('.product--content-description-button__container');
    var product = document.querySelector('.product__container');
    var prevPage = document.referrer.split('?')[0];
    var productID;
    let params = (new URL(document.location)).searchParams;
    let searchBar = params.get('search');

    if(product){
        if(!searchBar && (prevPage.includes('collections') || prevPage.includes('search'))){

            if(product){
                productID = product.id;
            }

            if(popularPlantsBtn) {
                popularPlantsBtn.addEventListener("click", function () {
                    var lastUrl = document.referrer;
                    let params = (new URL(lastUrl)).searchParams;
                    let selection = params.get('selected');
                    let q = params.get('q');
                    lastUrl = lastUrl.split('?')[0];

                    if(prevPage.includes('search')){
                        window.location.href = lastUrl.concat("?id=" + productID + "&q=" + q);
                    } else if(prevPage.includes('collections')) {
                        if(params.get('id')) {
                            window.location.href = lastUrl.concat("?selected=" + selection + "&id=" + productID);
                        } else if(!selection) {
                            window.location.href = document.referrer.concat("?id=" + productID);
                        } else {
                            window.location.href = document.referrer.concat("&id=" + productID);
                        }
                    }
                });
            }
        } else if(popularPlantsBtn){
            popularPlantsBtn.style.display = "none";
        }
    }


    // Only run on the product page
    if (document.getElementsByClassName("template-product").length === 0) {
        return;
    }

    /**
     * Data to keep track of:
     *  - JSON representation of cart (for slide-over)
     *  - JSON representation of product
     *  -
     *
     * Quantity buttons increase/decrease count.
     * Add to cart button
     *  - Increments Cart count to correct number
     */

    // Change product variant
    function changeProductVariant() {}

    // Add product to cart
    function addToCart() {}

    function updateCart() {}

    // Re-render the product data in the popover
    function updateCartPopover() {}

    // Toggles the slide in/out of the popoover
    function toggleCartPopover() {}

    // Change the product count in the header
    function updateCartCount(diff) {}
})();
